import { ThemeOptions } from '@mui/material';

const zIndex: ThemeOptions['zIndex'] = {
  mobileStepper: 1000,
  speedDial: 1100,
  appBar: 1200,
  drawer: 1700,
  snackbar: 1800,
  modal: 2000,
  tooltip: 2100
};

export default zIndex;
